// extracted by mini-css-extract-plugin
export var actionButton = "_nj-0";
export var actionMenuContainer = "_nj-i";
export var bubble = "_nj-2";
export var bubbleActionMenu = "_nj-j";
export var bubbleContext = "_nj-6";
export var bubbleItems = "_nj-7";
export var customer = "_nj-3";
export var divider = "_nj-8";
export var fileList = "_nj-9";
export var hiddenComment = "_nj-o";
export var infoAbove = "_nj-a";
export var internal = "_nj-4";
export var lightActionButton = "_nj-1";
export var link = "_nj-b";
export var merchant = "_nj-5";
export var message = "_nj-c";
export var profilePicture = "_nj-e";
export var quillToolbarContainer = "_nj-f";
export var senderDate = "_nj-g";
export var senderDateCustomer = "_nj-h";
export var senderName = "_nj-d";
export var time = "_nj-k";
export var uploadedImage = "_nj-l";
export var username = "_nj-m";
export var xsmall = "_nj-n";